import { IEntity } from 'app/projects/entity/src/lib/interfaces/entity.interface';
import { IGradingSchemeQuery } from '../interfaces/grading-scheme.query.interface';
import { Grade } from './grade.model';

export class GradingScheme implements IEntity {
    static label_singular = 'gradingScheme';
    static label_plural = 'gradingSchemes';

    static props_to_search = ['name', 'description'];

    id: string = null;
    name: string = null;
    minimumPassingGradeOrder: number = null;
    description: string;
    grades: Grade[] = null;
    rule: string = null;
    useGradeBox: boolean;

    constructor(query?: IGradingSchemeQuery) {
        if (query) {
            this.id = query.id.toString();
            this.name = query.name;
            this.minimumPassingGradeOrder = query.minimum_passing_grade_sequence;
            this.description = query.description;
            this.useGradeBox = query.use_grade_box;

            if (query.grades) {
                this.grades = query.grades.map((gradeQuery) => new Grade(gradeQuery)).sort((a, b) => (a.order > b.order ? -1 : b.order > a.order ? 1 : 0));
            }
        }
        this.rule = '';
    }
}
